"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    tr:nth-of-type(even) {\n      background-color: ", ";\n    }\n\n    tr:nth-of-type(odd) {\n      background-color: ", ";\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    tr:nth-of-type(even) {\n      background-color: ", ";\n    }\n\n    tr:nth-of-type(odd) {\n      background-color: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    tr:nth-of-type(even) {\n      background-color: ", ";\n    }\n\n    tr:nth-of-type(odd) {\n      background-color: ", ";\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      tr:nth-of-type(even) {\n        background-color: ", ";\n      }\n\n      tr:nth-of-type(odd) {\n        background-color: ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_VARIANT_TYPES = exports.tableBodyStripedCustomOdd = exports.tableBodyStripedCustomEven = exports.tableBodyStripedCustomEvenOdd = exports.tableBodyStripedDefault = exports.tableBody = void 0;

var _core = require("@emotion/core");

var _utilities = require("../../utilities");

var TABLE_VARIANT_TYPES = {
  default: 'default',
  striped: 'striped'
};
exports.TABLE_VARIANT_TYPES = TABLE_VARIANT_TYPES;

var tableBody = function tableBody() {
  return (0, _core.css)(_templateObject());
};

exports.tableBody = tableBody;

var tableBodyStripedDefault = function tableBodyStripedDefault(_ref) {
  var variant = _ref.variant,
      stripedColorEven = _ref.stripedColorEven,
      stripedColorOdd = _ref.stripedColorOdd,
      theme = _ref.theme;
  return variant === TABLE_VARIANT_TYPES.striped && !stripedColorEven && !stripedColorOdd && (0, _core.css)(_templateObject2(), _utilities.utilities.palette.color(theme, 'neutral00'), _utilities.utilities.palette.color(theme, 'neutral02'));
};

exports.tableBodyStripedDefault = tableBodyStripedDefault;

var tableBodyStripedCustomEvenOdd = function tableBodyStripedCustomEvenOdd(_ref2) {
  var variant = _ref2.variant,
      stripedColorEven = _ref2.stripedColorEven,
      stripedColorOdd = _ref2.stripedColorOdd,
      theme = _ref2.theme;
  return variant === TABLE_VARIANT_TYPES.striped && stripedColorEven && stripedColorOdd && (0, _core.css)(_templateObject3(), _utilities.utilities.palette.color(theme, stripedColorEven), _utilities.utilities.palette.color(theme, stripedColorOdd));
};

exports.tableBodyStripedCustomEvenOdd = tableBodyStripedCustomEvenOdd;

var tableBodyStripedCustomEven = function tableBodyStripedCustomEven(_ref3) {
  var variant = _ref3.variant,
      stripedColorEven = _ref3.stripedColorEven,
      stripedColorOdd = _ref3.stripedColorOdd,
      theme = _ref3.theme;
  return variant === TABLE_VARIANT_TYPES.striped && stripedColorEven && !stripedColorOdd && (0, _core.css)(_templateObject4(), _utilities.utilities.palette.color(theme, stripedColorEven), _utilities.utilities.palette.color(theme, 'neutral01'));
};

exports.tableBodyStripedCustomEven = tableBodyStripedCustomEven;

var tableBodyStripedCustomOdd = function tableBodyStripedCustomOdd(_ref4) {
  var variant = _ref4.variant,
      stripedColorEven = _ref4.stripedColorEven,
      stripedColorOdd = _ref4.stripedColorOdd,
      theme = _ref4.theme;
  return variant === TABLE_VARIANT_TYPES.striped && !stripedColorEven && stripedColorOdd && (0, _core.css)(_templateObject5(), _utilities.utilities.palette.color(theme, 'neutral00'), _utilities.utilities.palette.color(theme, stripedColorOdd));
};

exports.tableBodyStripedCustomOdd = tableBodyStripedCustomOdd;